export default "__VITE_ASSET__DEbj_7oW__"